export function canViewStatsWeek(week, currentWeek, hasPicks, hasRankings, guest = false) {
  return Number.isInteger(week) && week >= 1 && week <= 18 &&
    (week < currentWeek || (week === currentWeek && !guest && hasPicks && hasRankings));
}

export function visibleStatsWeeks(currentWeek, hasPicks, hasRankings, guest = false) {
  return Array.from({ length: 18 }, (_, i) => i + 1)
    .filter(week => canViewStatsWeek(week, currentWeek, hasPicks, hasRankings, guest));
}

export function hasPostedResults(winners, week) {
  return Boolean(winners?.[week]?.data?.picks?.length);
}
